export default __webpack_public_path__ + "static/stepOneMeasureYourFinger-3a01260a8db8f6d2e04af713baf2ea1a.png";